import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import styled from "styled-components";

import { lighten, darken } from "../actions";

import Container from "../containers/container";
import Header from "../containers/header"
import About from "../containers/about";

import ProjectCard from "../components/ProjectCard"

import nb from "../images/nb/nb0.png"
import ren from "../images/ren/ren06.png"
import bp from "../images/bp/ff01.png"

const Hero = styled.div`
  width: 100%;
  padding: 96px 0 96px 0;
  box-sizing: border-box;
  position: relative;
  overflow: visible;

  display: flex;
  justify-content: space-between;
  align-items: center;


  @media (max-width: 425px) {
    padding-top: 30px;
  }
`;

const Work = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 120px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

const Movement = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <>
      <a className="anchor" id="about"></a>
      <Container>
        <Hero>
          <About>
            <h1>movement</h1>
          </About>
        </Hero>
        <a className="anchor" id="work"></a>
        <Work>
          <ProjectCard href="/movement/nb">
            <div className="image-wrapper">
              <img src={nb} alt="new balance london marathon" />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">new balance london marathon</h3>
                <h4>movement direction</h4>
              </div>
              <p>
                I directed 8 models in total in various poses to create a dynamic flow.
              </p>
            </div>
          </ProjectCard>

          <ProjectCard href="/movement/renovations">
            <div className="image-wrapper">
              <img src={ren} alt="renovations" />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">renovations</h3>
                <h4>dance film</h4>
              </div>
              <p>
                A man examines his past. Confronted with the fact that he, his talents, and his relationships have all changed, he searches for a way to navigate the future.
              </p>
            </div>
          </ProjectCard>

          <ProjectCard href="/movement/BP">
            <div className="image-wrapper">
              <img src={bp} alt="Body Politic" />
            </div>
            <div>
              <div className="project-header">
                <h3 className="project-title">Body Politic</h3>
                <h4>choreography</h4>
              </div>
              <p>
                Choreographer, dancer, and director residency ('14 — '17), collaborating on theater shows, live performances, and digital video campaigns.
              </p>
            </div>
          </ProjectCard>
        </Work>
        <a className="anchor" id="contact"></a>
      </Container>
    </>
  );
};

export default Movement;
